<template>
  <div class="flex flex-row mt-24">
    <div v-for="index in steps" :key="index" class="step" :class="{ current: step === index }" />
  </div>
</template>

<script>
export default {
  name: 'StepDots',
  props: {
    steps: Number,
    step: Number,
  },
};
</script>

<style lang="scss" scoped>
.step {
  min-width: 8px;
  height: 8px;
  border: 1px solid #540deb;
  border-radius: 100%;
  background-color: white;
  margin: 0 5px;
  &.current {
    background: linear-gradient(90deg, #540deb 11.03%, #2245ff 83.45%);
  }
}
</style>
